<template>
  <section
    class="commentBar"
    :style="{position: fixed ? 'fixed' : 'relative', top: fixed ? celling + 'px' : ''}">
    <span>{{ quantity | numberFormat }}条</span>
    <img src="../../assets/images/comment_btn.png" @click="handleComment" alt="comment"/>
  </section>
</template>

<script>
export default  {
  props: {
    quantity: {
      type: Number,
      default: 0
    },

    comment: {
      type: Function,
      default: () => alert('Comment')
    },

    fixed: {
      type: Boolean,
      default: false
    },

    celling: {
      type: Number,
      default: 0
    }
  },

  filters: {
    numberFormat (value) {
      if (value >= 999) {
        return '999+'
      } else {
        return value
      }
    }
  },

  methods: {
    handleComment () {
      this.$emit('comment')
    }
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

.commentBar {
  position: relative;
  height: rem(110);
  width: 100%;
  text-indent: rem(30);
  /*background-color: #F0F0F0;*/

  span {
    color: #999;
    font-size: rem(24);
    line-height: rem(110);
  }

  img {
    position: absolute;
    top: 0; bottom: 0;
    right: rem(30);
    margin: auto 0;
    /*height: rem(56);*/
    width: rem(180);
  }
}

</style>
